// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ktbaEeu_oIvFPdfK58yN{flex-direction:column;gap:2px;display:flex}.ktbaEeu_oIvFPdfK58yN .iwF9AhnfX8ImIRcQOvBb{width:100%;color:var(--content-primary-primary);padding:8px 8.5px!important}.Nfk2RRmpmYyryr3QkLfm{justify-content:flex-start;align-items:center;padding:8.5px 8px;display:flex}.Fxk3r1vxJJ0K5VHEMhiO{margin-left:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `ktbaEeu_oIvFPdfK58yN`,
	"status": `iwF9AhnfX8ImIRcQOvBb`,
	"title": `Nfk2RRmpmYyryr3QkLfm`,
	"titleStatus": `Fxk3r1vxJJ0K5VHEMhiO`
};
export default ___CSS_LOADER_EXPORT___;
